import * as settings from "./globals";
import { showModal, hideModal } from "./utilities";

// warning message for IE 6/7/8
export function showDeprecatedBrowserMessage () {
    showModal(settings.warningMsgId);
}

export function hideDeprecatedBrowserMessage () {
    hideModal(settings.warningMsgId);
}

// Intelligate warning message
export function showSecurityWarningMessage () {
    showModal(settings.securityWarningId);
}

export function hideSecurityWarningMessage () {
    hideModal(settings.securityWarningId);
    ConfigChecker.checkSecurityPackage({ forceAccess: true });
}